import uniqBy from 'lodash/uniqBy';
import { useStore } from '../store/provider';
import { Hotel, HotelFragmentFragment } from '../generated/types';
import React, { useMemo } from 'react';

export default function useHotelMapMarkers(data: HotelFragmentFragment) {
  const store = useStore();
  return useMemo(() => {
    let markers: any[] = [];

    if (data.activities) {
      markers = markers.concat(data.activities);
    }

    if (data.pois) {
      markers = markers.concat(data.pois);
    }

    if (data.activitiesInRegion) {
      markers = markers.concat(data.activitiesInRegion.items);
    }

    if (
      store.config.renderConfig.hotel.nearActivities &&
      data.nearActivities &&
      data.nearActivities.total > 0
    ) {
      markers = markers.concat(data.nearActivities.items);
    }

    if (
      store.config.renderConfig.hotel.nearPois &&
      data.nearPois &&
      data.nearPois.total > 0
    ) {
      markers = markers.concat(data.nearPois.items);
    }

    // Filter unique
    return uniqBy(markers, 'id');
  }, [data]);
}
